import {
  Component,
  Host,
  h,
  Element,
  Prop,
} from "@stencil/core";

import { hasSlot } from "../../utils/utils";

/**
 * @slot - Slot for e.g. image or video
 * @slot caption - Slot for a caption as alternative for attribute
 * @slot copyright - Slot for a copyright as alternative for attribute
 * @slot counter - Slot for a counter as alternative for attribute
 * @slot heading - Slot for a heading as alternative for attribute
 */
@Component({
  tag: "stzh-figure",
  styleUrl: "stzh-figure.scss",
  scoped: true
})
export class StzhFigure {
  /** Caption */
  @Prop() caption: string = "";

  /** Copyright */
  @Prop() copyright: string = "";

  /** Counter */
  @Prop() counter: string = "";

  /** Heading */
  @Prop() heading: string = "";

  /** Whether to stretch slotted content to fullwidth */
  @Prop({ reflect: true }) fullwidth: boolean = true;

  @Element() element: HTMLStzhFigureElement;

  render() {
    const captionSlotUsed = hasSlot(this.element, 'caption');
    const copyrightSlotUsed = hasSlot(this.element, 'copyright');
    const counterSlotUsed = hasSlot(this.element, 'counter');
    const headingSlotUsed = hasSlot(this.element, 'heading');

    const classes = {
      "stzh-figure": true,
      "stzh-figure--has-caption":
        !!this.caption || captionSlotUsed
        || !!this.copyright || copyrightSlotUsed
        || !!this.counter || counterSlotUsed
        || !!this.heading || headingSlotUsed
    };

    return (
      <Host>
        <figure class={classes}>
          <div class="stzh-figure__element">
            <slot></slot>
          </div>
          <figcaption class="stzh-figure__caption-wrapper">
            <div class="stzh-figure__heading-wrapper">
              <div class="stzh-figure__counter">
                {this.counter ? this.counter : <slot name="counter"></slot>}
              </div>
              <div class="stzh-figure__heading">
                {this.heading ? this.heading : <slot name="heading"></slot>}
              </div>
            </div>
            <div class="stzh-figure__caption">
              <div class="stzh-figure__caption-text">
                {this.caption ? this.caption : <slot name="caption"></slot>}
              </div>
              <div class="stzh-figure__copyright">
                {this.copyright ? this.copyright : <slot name="copyright"></slot>}
              </div>
            </div>
          </figcaption>
        </figure>
      </Host>
    );
  }
}
